import React from 'react'
import { Container, Grid, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import styles from './styles'
import { useClientApiContext } from '../context/ClientApiContextProvider'
import { postLog } from '../../services/client'

const Http404 = () => {
  const [searchParams] = useSearchParams()
  const url: string | null = searchParams.get('u')
  const errCode: string | null = searchParams.get('r')
  const useClientContext = useClientApiContext()

  useEffect(() => {
    if (url || errCode)
      postLog(useClientContext.client, {
        level: 'warn',
        message: 'Library 404',
        data: { url, errCode }
      })
  }, [useClientContext.client, url, errCode])

  return (
    <Container
      style={{
        maxWidth: 1200,
        padding: 50,
        display: 'flex',
        flexDirection: 'column',
        gap: 75
      }}
    >
      <Grid style={styles.container}>
        <h1 style={styles.headers}>404</h1>
        <Typography style={styles.paragraph}>Not Found</Typography>
      </Grid>
    </Container>
  )
}

export default Http404
